import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { useTheme } from '../../../styles/ThemeProvider';
import { buildTooltipStyle } from './tooltipStyle';

export const CategoryBar = ({ data, labelKey = 'label', valueKey = 'value', formatter }) => {
  const { theme } = useTheme();
  const tip = buildTooltipStyle(theme);
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, left: 16, bottom: 0 }}>
        <CartesianGrid stroke={theme.color.border} strokeDasharray="3 3" horizontal={false} />
        <XAxis type="number" stroke={theme.color.muted} fontSize={12} tickFormatter={formatter} tickLine={false} axisLine={false} />
        <YAxis type="category" dataKey={labelKey} stroke={theme.color.muted} fontSize={12} tickLine={false} axisLine={false} width={120} />
        <Tooltip {...tip} formatter={formatter ? (v) => formatter(v) : undefined} />
        <Bar dataKey={valueKey} fill={theme.color.accent} radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
